import React, { Component } from "react";
import {
    Form,
    Button,
    Container,
    Row,
    Col,
    Jumbotron,
    InputGroup,
    FormControl,
    Alert,
    Accordion,
    Card, ListGroup
} from "react-bootstrap";
import Axios from 'axios';
import Footer from "../../Footer";
import {Link} from "react-router-dom";
import loadingSvg from "../../images/loading.svg";
import {ContextAwareToggle} from "../../bootstrapOverwrites/ContextAwareToggleComponent";
import AddBoardPOI from "../EditBoard/AddBoardPOI";
import  {ReactComponent as ArrowSvg} from "../../images/arrow.svg"
import EditBoardPOI from "../EditBoard/EditBoardPOI";
import FoursquareCategories from "../../foursquare_categories.json";

export default class EditCampaignView extends Component{
    state = {
        POIs : [],
        complianceOn: false,
    };

    getBoardApi(){
        let campaignId  = this.props.match.params.campaignId;
        console.log(campaignId);
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.campaign){
                let campaign = response.data.campaign;
                console.log(response);
                console.log(response.data);
                console.log(campaign);
                this.setState({campaign: campaign, POIs:campaign.POIs, complianceOn: campaign.complianceOn});
            }else{
                this.setState({campaignGetError:"Unable to find campaign." });
            }
        }).catch(error => {
            console.log(error);
            if(error && error.response){
                this.setState({campaignGetError:error.response.data.message});
            }
        });
    }
    componentDidMount() {
        this.getBoardApi();
    }

    dismissAlerts = (event) => {
        this.setState({campaignGetError:undefined})
    }

    addPoi = (poiCategory) =>  {
        let pois = this.state.POIs;
        if(pois.length > 4){
            this.setState({error: {
                    title: "Unable to Add Poi",
                    body: "Campaigns are limited to 5 POIs",
                }});
        }else{
            if(!poiCategory){
                pois.push(this.state.poiInput);
            }else{
                pois.push(poiCategory);
            }
            this.setState({POIs: pois, poiInput: ""});
        }
    }
    removePOI = (i) =>  {
        let pois = this.state.POIs;
        pois.splice(i, 1);
        this.setState({POIs: pois});
    }

    matchesPOICategorySearch(category, search){
        search = search.toLowerCase();
        let label = category.labels.en.toLowerCase();
        if(label.includes(search)){
            return true
        }
        for(let fl of category.full_label) {
            fl = fl.toLowerCase();
            if (fl.includes(search)) {
                return true
            }
        }
        return false
    }

    deleteCampaign() {
        let campaignId = this.props.match.params.campaignId;
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-campaign",{
            campaignId: campaignId,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            this.setState({alert:{
                    title:"Campaign Deleted!",
                    body:"The campaign has been successfully removed from the campaign. Redirecting to the campaigns page..."
                }});
            setTimeout(()=>{
                this.setState({
                    alert: null
                })
                window.location.replace("/campaigns");
            },3000)
        }).catch(err => {
            console.log(err)
            console.log(err.response.data);
            this.setState({error:{
                    title:"Campaign unable to be deleted!",
                    body:"Server reported an error: " +err.response.data.message,
                }});
            setTimeout(()=>this.setState({
                error: null
            }),3000)
        });
    }

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        data.append("campaignId",this.state.campaign._id);
        data.append("campaignName",form["campaignName"].value);
        data.append("startDate",form["startDate"].value);
        data.append("endDate",form["endDate"].value);
        data.append("complianceOn",this.state.complianceOn);
        data.append("complianceRadius",form["complianceRadius"] ? form["complianceRadius"].value : undefined);
        data.append("POIs",this.state.POIs);
        // data.append("POIsFound",JSON.stringify(this.state.campaign.POIsFound));
        data.append("POIsArray",JSON.stringify(this.state.campaign.POIsArray ? this.state.campaign.POIsArray : []));

        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/edit", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            this.setState({alert:{
                    title:"Campaign Updated!",
                    body:"The campaign has been successfully updated. It may take a few minutes for the changes to take effect."
                }});
            setTimeout(()=>{
                this.setState({
                    alert: null
                })
            },3000)
        }).catch(error => {
            this.setState({campaignCreatedError:error.response.data.message});
        });
    }
    //todo: on submit "remake" campaign
    render() {
        return <div className={"main-container"}>
            <Container>
                <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>
                    <Form onSubmit={this.onSubmit}>
                        <Row className={"mb-4"}>
                            <Col>
                                <h2>Edit Campaign</h2>
                            </Col>
                        </Row>
                        {this.state.campaign ?
                            <>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="campaignName">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control type="text" defaultValue={this.state.campaign.name} placeholder="Enter name of campaign" required/>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="startDate">
                                            <Form.Label>Start Date</Form.Label>
                                            <Form.Control type="date" defaultValue={this.state.campaign.startDate ? this.state.campaign.startDate.split("T")[0]: ""} required/>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId="endDate">
                                            <Form.Label>End Date</Form.Label>
                                            <Form.Control type="date" defaultValue={this.state.campaign.endDate ? this.state.campaign.endDate.split("T")[0]: ""} required/>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <label>POIs</label>
                                        <InputGroup className="mb-3">
                                            {/*<InputGroup.Label>*/}
                                            {/*    POIs*/}
                                            {/*</InputGroup.Label>*/}
                                            <FormControl
                                                placeholder="Enter query fields"
                                                aria-label="Enter query fields"
                                                aria-describedby="basic-addon2"
                                                value={this.state.poiInput}
                                                onChange={e => this.setState({ poiInput: e.target.value })}
                                            />
                                            <InputGroup.Append>
                                                <Button onClick={()=>{this.addPoi()}} variant="primary">Add POI</Button>
                                            </InputGroup.Append>
                                        </InputGroup>
                                        {this.state.poiInput && this.state.poiInput.length ?<ListGroup className={"mb-4"} style={{maxHeight:200,overflow:"scroll",fontSize:"0.8rem"}}>
                                            {Object.keys(FoursquareCategories).map((key,i) => {
                                                let category = FoursquareCategories[key];
                                                if(!this.matchesPOICategorySearch(category,this.state.poiInput)){
                                                    return <></>
                                                }
                                                return <ListGroup.Item key={i} action onClick={(ev)=>{ev.preventDefault();this.addPoi(category.labels.en)}}>
                                                    {category.full_label.length > 1 ? category.labels.en : <b>{category.labels.en}</b>}
                                                </ListGroup.Item>
                                            })}
                                        </ListGroup> :""}
                                        <p className={"mb-4"}><i>The autofilled POI's have better results.</i></p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className={"added-poi-container"}>
                                        {this.state.POIs.map((poi,i) => {
                                            return <div className={"green-btn ft-md added-poi"} key={i}>{poi}<div onClick={()=>this.removePOI(i)} className={"close-icon"}/></div>
                                        })}
                                    </Col>
                                </Row>
                                <Row className={"mb-4"}>
                                    <Col>
                                        <Accordion>
                                            <Card>
                                                {/*<Accordion.Toggle as={Card.Header} eventKey="0">*/}
                                                {/*    Metadata*/}
                                                {/*</Accordion.Toggle>*/}
                                                <Card.Header>
                                                    {/*<Accordion.Toggle as={Card.Header} eventKey="2" onClick={()=>{this.props.togglePOIsPins()}}>*/}
                                                    <ContextAwareToggle
                                                        eventKey="2"
                                                        // clickEvent={(ev)=>{this.putAtTop(ev);}}
                                                    >POIs <ArrowSvg className={"accordion-arrow"}/></ContextAwareToggle>
                                                    {/*</Accordion.Toggle>*/}
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        {/*<div className={"compliance-accordion"}>*/}
                                                        {this.state.campaign && this.state.campaign.POIsArray && this.state.campaign.POIsArray.length ?
                                                            this.state.campaign.POIsArray.map((poi) => {
                                                                return <EditBoardPOI
                                                                    key={poi.place_id}
                                                                    poi={poi}
                                                                    campaign={this.state.campaign}
                                                                    // board={this.state.board}
                                                                    update={(campaign)=>{
                                                                        this.setState({campaign:campaign});
                                                                        // this.saveChanges();
                                                                    }}
                                                                />
                                                            }) : <>
                                                                <i>No POIs Found</i>
                                                            </>}
                                                        {/*</div>*/}
                                                        <hr className={"w-100"}/>
                                                        <AddBoardPOI
                                                            // board={this.state.board}
                                                            campaign={this.state.campaign}
                                                            update={(campaign)=>{
                                                                this.setState({campaign:campaign});
                                                                // this.saveChanges();
                                                            }}
                                                        />
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className={"d-inline-block"}>Compliance</p>
                                        <Form.Check
                                            className={"d-inline-block ml-3"}
                                            type="switch"
                                            id="custom-switch"
                                            checked={this.state.complianceOn}
                                            onChange={()=>this.setState({complianceOn: !this.state.complianceOn})}
                                        />
                                    </Col>
                                    <Col>

                                    </Col>
                                </Row>
                                {this.state.complianceOn ?
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="complianceRadius">
                                                <Form.Label>Compliance Radius (ft)</Form.Label>
                                                <Form.Control type="number" max={10560} min={100} placeholder={"5280 (1 Mi)"}
                                                              defaultValue={this.state.campaign.complianceRadius/0.3048}//convert meter -> foot
                                                              required/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    :<></>
                                }
                                <Row className={"mt-4"}>
                                    <Col className={"text-left"}>
                                        {/*TODO: are you sure tooltip*/}
                                        <span onClick={()=>{this.deleteCampaign()}} className={"red-txt delete-board-btn boring-btn mt-1 d-inline-block"}>Delete Campaign</span>
                                    </Col>
                                    <Col className={"text-right"}>
                                        <span onClick={function (){
                                            window.location.reload();
                                        }} className={"mr-2 boring-btn"}>Reset</span>
                                        <Button variant="primary" type="submit">
                                            Edit Campaign
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                            :<></>}
                    </Form>
                <div className={"text-center mt-5"}>
                        {this.state.campaign ?
                            <>
                                <p>Looking for the <b>Upload Media</b> page?</p>
                                <Link to={`/campaign/${this.state.campaign._id}/upload`} className={"boring-btn"}>+ Upload Media</Link>
                            </>
                        :<>
                                <img className={"loading-icon-sm"} src={loadingSvg}  alt={"loading icon"}/>
                            </>
                        }
                    </div>
                    <div className={"text-center mt-5"}>
                        {this.state.campaign ?
                            <>
                                <p>Looking for the <b>Edit Media</b> page?</p>
                                <Link to={`/campaigns/${this.state.campaign._id}/edit-boards`} className={"boring-btn"}>Edit Media</Link>
                            </>
                            :<>

                            </>
                        }
                    </div>
                </Jumbotron>
                <div className={"mx-auto mt-5"}>
                </div>
                {this.state.alert ? (
                    <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="success" onClose={()=>{this.setState({alert: null})}} dismissible>
                        <Alert.Heading>{this.state.alert.title}</Alert.Heading>
                        <p>{this.state.alert.body}</p>
                    </Alert>
                ):(
                    <></>
                )}
                {this.state.error ? (
                    <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                        <Alert.Heading>{this.state.error.title}</Alert.Heading>
                        <p>{this.state.error.body}</p>
                    </Alert>
                ):(
                    <></>
                )}
                <Footer/>
            </Container>
        </div>
    }
}
